import {Component, Input, OnInit} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {
  BusinessPropertiesService,
  BusinessUnitIdDto,
  DictionaryBaseService,
  DictionaryDto,
  DictionaryService,
  LoggedUserService,
  PolicyContractService,
  PolicyContractVersionDto,
  PolicyInquiryTypeEnum,
  RouterService,
  UserIdDto,
  UserService,
} from '../../../bonding_shared';
import {AbstractInquiryProduct} from './abstract-inquiry.product';
import {VisibilityService} from '../services/visibility.service';

@Component({
  selector: 'inquiry-product-credendo-single-risk',
  templateUrl: './inquiry-product-credendo-single-risk.component.pug',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class InquiryProductCredendoSingleRiskComponent extends AbstractInquiryProduct implements OnInit {
  @Input()
  myOptions: DictionaryDto[];

  underwriters: UserIdDto[] = null;

  readonly policyInquiryType = 'POLICY_INQUIRY';

  constructor(
    dictionaryBaseService: DictionaryBaseService,
    router: RouterService,
    private userService: UserService,
    protected policyContractService: PolicyContractService,
    private dictionaryService: DictionaryService,
    protected businessPropertiesService: BusinessPropertiesService,
    protected loggedUserService: LoggedUserService,
    protected visibilityService: VisibilityService
  ) {
    super(
      dictionaryBaseService,
      router,
      loggedUserService,
      policyContractService,
      businessPropertiesService,
      visibilityService
    );
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.loadUnderwriters();

    this.formUpdate();
  }

  protected loadSalesUsers() {
    const businessUnit: BusinessUnitIdDto = this.inquiry.businessUnit;
    this.userService.getSalesUsers(businessUnit).subscribe((users) => {
      this.salesUsers = users;
    });
  }

  protected loadUnderwriters() {
    if (!this.readonly) {
      this.userService.getPolicySupport().subscribe((res) => {
        this.underwriters = res;
      });
    }
  }

  onSelectPolicy(c: PolicyContractVersionDto) {
    this.inquiry.policyInquiry.policyContract = c.policyContract;
  }
}
